import { hasChildren } from "shared/lib/hasChildren"

import { FlattenedTableItemType } from "../types"

export const getHeight = (
  nodes: FlattenedTableItemType[],
  index: number
): number => {
  if (!hasChildren(nodes[index])) {
    return 1
  }
  const { level } = nodes[index]

  for (let i = index + 1; i < nodes.length; i += 1) {
    if (nodes[i].level <= level) {
      return i - index
    }
  }
  return nodes.length - index
}
